import {
  HeadContent,
  Scripts,
  Outlet,
  createRootRoute,
} from "@tanstack/react-router"
import { useEffect } from "react"
import { ClerkProvider, useAuth as useClerkAuth } from "@clerk/clerk-react"
import { ConvexReactClient } from "convex/react"
import { ConvexProviderWithClerk } from "convex/react-clerk"
import { initSentry } from "@/lib/analytics/sentry"
import { ThemeProvider } from "@/lib/theme"
import appCss from "../styles.css?url"

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string, {
  unsavedChangesWarning: false,
})
const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as
  | string
  | undefined

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { title: "Wild Guess Trivia" },
      {
        name: "description",
        content: "Coming soon.",
      },
    ],
    links: [
      { rel: "stylesheet", href: appCss },
      { rel: "icon", href: "/wild-guess-logo.png", type: "image/png" },
    ],
  }),
  component: RootComponent,
  shellComponent: RootDocument,
})

function RootDocument({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <HeadContent />
      </head>
      <body className="font-sans antialiased min-h-screen">
        {children}
        <Scripts />
      </body>
    </html>
  )
}

function RootComponent() {
  useEffect(() => {
    initSentry()
  }, [])

  return (
    <ThemeProvider>
      {clerkPublishableKey ? (
        <ClerkProvider
          publishableKey={clerkPublishableKey}
          signInUrl="/sign-in"
          afterSignOutUrl="/"
        >
          <ConvexProviderWithClerk client={convex} useAuth={useClerkAuth}>
            <Outlet />
          </ConvexProviderWithClerk>
        </ClerkProvider>
      ) : (
        <div className="flex min-h-screen items-center justify-center bg-[color:var(--background)] px-6 text-center">
          <div className="max-w-sm">
            <img
              src="/wild-guess-logo.png"
              alt=""
              className="mx-auto mb-4 h-14 w-14 opacity-50"
            />
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[color:var(--muted-foreground)]">
              Missing Clerk config
            </p>
            <p className="mt-3 text-sm leading-6 text-[color:var(--muted-foreground)]">
              Set VITE_CLERK_PUBLISHABLE_KEY to enable sign-in.
            </p>
          </div>
        </div>
      )}
    </ThemeProvider>
  )
}
